import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSafeRedirect } from '@/utils';
import { SignInEmail } from '@/pages';

export const Route = createFileRoute('/_public/signin/email')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  beforeLoad: ({ context, search }) => {
    if (!context.auth.isLoading && context.auth.isAuthenticated) {
      throw redirect({ to: getSafeRedirect(search.redirect) ?? '/dashboard', replace: true });
    }
  },
  component: SignInEmail,
});
